import { Box, RadioGroup, Stack, Text } from "@chakra-ui/react";

import { TagOption } from "./tag-option";
import { TagOptionType as SelectOptionType } from "./types";

type TagSelectListProps<T extends string> = {
  name: string;
  description?: string;
  value?: T | null;
  onChangeValue?: (value: T) => void;
  options: SelectOptionType<T>[];
};

export const TagSelectList = <T extends string>({
  name,
  description,
  options,
  value,
  onChangeValue,
}: TagSelectListProps<T>) => {
  return (
    <Box paddingBlock="6px" paddingInline={0}>
      {description && (
        <Text fontSize={12} fontWeight={500} paddingInline={6} paddingBlock={2}>
          {description}
        </Text>
      )}
      <RadioGroup.Root value={value} onValueChange={e => onChangeValue?.(e.value as T)}>
        <Stack paddingInline="6px" overflow="auto" py={1} direction="column" gap={1}>
          {options.map(option => (
            <TagOption
              key={option.value}
              checked={value === option.value}
              label={option.label}
              value={option.value}
              color={option.color}
              name={name}
              onChangeValue={() => onChangeValue?.(option.value)}
              disabled={option.disabled}
            />
          ))}
        </Stack>
      </RadioGroup.Root>
    </Box>
  );
};
